import {Text, Modal, Button} from '@nike/eds';
import { ApolloError } from '@apollo/client';

export const GqlErrorModal = ({error, onClose}: {error: ApolloError | undefined, onClose: () => void}) => {
  return (
    <Modal isOpen={!!error} onDismiss={onClose}
      headerSlot={
        <Text as='h2' font={'title-5'}>GraphQL Error</Text>
      }
      footerSlot={
        <Button variant="secondary" onClick={onClose}>Close</Button>
      }>
        {error && (
          <div className="eds-spacing--p--24">
            {error.message && (
              <Text as="div" font="body-2" color="danger" className="eds-spacing--mb-16">
                <strong>Message:</strong> {error.message}
              </Text>
            )}

        {error.graphQLErrors && error.graphQLErrors.length > 0 && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>GraphQL Errors:</strong>
            </Text>
            <ul>
              {error.graphQLErrors.map((gqlErr, idx) => (
                <li key={idx}>
                  <Text as="div" font="body-3">
                    {gqlErr.message}
                    {gqlErr.extensions && (
                      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {JSON.stringify(gqlErr.extensions, null, 2)}
                      </pre>
                    )}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}

        {error.protocolErrors && error.protocolErrors.length > 0 && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>Protocol Errors:</strong>
            </Text>
            <ul>
              {error.protocolErrors.map((protoErr, idx) => (
                <li key={idx}>
                  <Text as="div" font="body-3">
                    {protoErr.message}
                    {protoErr.extensions && (
                      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {JSON.stringify(protoErr.extensions, null, 2)}
                      </pre>
                    )}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}

        {error.clientErrors && error.clientErrors.length > 0 && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>Client Errors:</strong>
            </Text>
            <ul>
              {error.clientErrors.map((clientErr, idx) => (
                <li key={idx}>
                  <Text as="div" font="body-3">
                    {clientErr.message}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}

        {error.networkError && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>Network Error:</strong>
            </Text>
            <Text as="div" font="body-3">
              {error.networkError.message}
            </Text>
          </div>
        )}

        {error.extraInfo && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>Extra Info:</strong>
            </Text>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {JSON.stringify(error.extraInfo, null, 2)}
            </pre>
          </div>
        )}

        {error.cause && (
          <div className="eds-spacing--mb-16">
            <Text as="div" font="body-2" color="danger">
              <strong>Cause:</strong>
            </Text>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {JSON.stringify(error.cause, null, 2)}
            </pre>
          </div>
        )}
      </div>
        )}
    </Modal>
  );
};
